import { debug, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { hasError } from "types/error";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { GIGStore } from "./GIGStore";

type IProps = RouteComponentProps<{}> & {
    store: GIGStore;
};

@observer
export class GIGSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                signingInfo={this.props.store.putEcommerceResponse ? this.props.store.putEcommerceResponse.signInfo : undefined}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>
                                {ui.__("gig.signing.label")}
                            </pr.SigningLabel>
                        </pr.SigningLabelContainer>
                    </div>

                }
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute("success");
                }}
                onError={(error: any) => {
                    if (hasError(error, {
                        scope: "signingObject.card",
                        error: "OPEN_PENDING_REQUEST"
                    })) {
                        pushRoute("/error/changeRepayment.error.pending");
                    }
                }}
                onRetry={async () => await this.props.store.activate()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gig/GIGSigning.tsx